import actionCreatorFactory from 'typescript-fsa';

import { IImpersonationPayload } from '../../../../interfaces/impersonation';

export const actionCreator = actionCreatorFactory();
export const ImpersonationActions = {
  setPayload: actionCreator.async<IImpersonationPayload, IImpersonationPayload, Error>('set:impersonation:payload'),
  reset: actionCreator.async<{}, void, Error>('reset:impersonation:payload')
};
